import { isWindowAvailable } from '../utils/browserObjectsAvailability';

export const useWindowLocation = () => {
  const getWindowLocation = () => {
    if (!isWindowAvailable()) {
      return null;
    }

    return window.location;
  };

  return getWindowLocation;
};
